module.exports = __webpack_public_path__ + "img/auto-optimize-banner.f3db3d45.svg";